/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */

import React, {
  Component,
  createContext,
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import intl from 'react-intl-universal';
import Axios from '../../config/Axios';
import AltCheckbox from '../../components/AltCheckbox';
import Filter from '../default-v2/Filter';
import CardHeader from '../default-v2/CardHeader';
import { Alert } from '../../components/Alert';
import './styles/qualitypanelconsultant.scss';
import { textSearchFormat } from '../norm/RequisiteIndex';
import Masonry from 'react-masonry-component';
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import EncodedLocalStorage from '../../config/EncodedLocalStorage';
import { BrandImage } from '../../config/ApperanceContext';
import { signIn } from '../../config/Authentication';

const oLocalStorage = new EncodedLocalStorage();
class QualityPanelIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bShowCompletedCertifications: false,
      aPages: [{ cName: 'QualityPanelConsultant.titulo', cLink: undefined }],
      rcmpAlert: null
    };

    this.searchTimer = React.createRef();
  }

  setAlert = (cType, cMessage) => {
    this.setState({
      rcmpAlert: (
        <Alert type={cType} isOpen onCloseAlert={() => { }}>
          {cMessage}
        </Alert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      rcmpAlert: null
    });
  };

  msgSucesso = msg => {
    this.hideAlert();
    this.componentDidMount();

    this.setAlert('success', msg);
  };

  onError = (oError) => {
    if (oError.response?.data) {
      this.setAlert('error', oError.response.data);
    }
  }

  validateCustomer = (oCompanie, nNormId, bAudit) => {
    if (oCompanie.cust_status === 'inactive' && !oCompanie.bisadmin) {
      this.setAlert('error', `Cliente está inativo desde ${oCompanie.cust_dinactive}`);
      return;
    }

    let cCustId = oLocalStorage.get('nCustId');
    if (cCustId && oCompanie.cust_nid !== parseInt(cCustId)) {
      this.setState({
        rcmpAlert: (
          <SweetAlert
            closeOnClickOutside={false}
            showCancel
            confirmBtnText={intl.get('confirmar')}
            cancelBtnText={intl.get('cancelar')}
            cancelBtnBsStyle="danger"
            title={intl.get('QualityPanelConsultant.confirm_company_change_title')}
            onConfirm={() => {
              this.changeCustomer(oCompanie, nNormId, bAudit);
              this.hideAlert();
            }}
            onCancel={this.hideAlert}
          >
            {intl.getHTML('QualityPanelConsultant.confirm_company_change_msg', { cName: oCompanie.cust_cfantasyname })}
          </SweetAlert>
        )
      });
      return;
    }
    this.changeCustomer(oCompanie, nNormId, bAudit);
  };

  changeCustomer = (oCompanie, nNormId, bAudit) => {
    const { router } = this.props;
    const navigate = (router && router.navigate) || (() => { });

    Axios.get(`customer/connect/${oCompanie.cust_nid}`)
      .then(oRes => {
        signIn(oRes.data, true);
        Axios.defaults.headers.common['nCustId'] = oCompanie.cust_nid;

        if (bAudit) navigate(`/requisite/${nNormId}`);
        else navigate(`/quality-panel/`);
      })
      .catch(oError => {
        this.setAlert('error', oError.response.data);
      });
  };

  handleChangeState = e => {
    this.setState({
      [e.target.name]: e.target.checked
    });
  };

  handleChangeFilter = (e, oFilter) => {
    if (this.searchTimer.current) clearTimeout(this.searchTimer.current);
    this.searchTimer.current = setTimeout(() => {
      this.setState({ filterSearch: oFilter.cText });
    }, 500);
  };

  generateCardHeader = () => {
    const { bShowCompletedCertifications } = this.state;

    const aCheckboxes = [];
    const rcmpCompletedCertificationsSwitch = (
      <AltCheckbox
        key="checkbox-show-completed"
        onChange={this.handleChangeState}
        title={intl.get('QualityPanelConsultant.certificacoes_concluidas')}
        label={intl.get('QualityPanelConsultant.certificacoes_concluidas')}
        name="bShowCompletedCertifications"
        localeLabel="end"
        checked={bShowCompletedCertifications}
      />
    );
    aCheckboxes.push(rcmpCompletedCertificationsSwitch);

    const rcmpFilter = <Filter fnOnType={this.handleChangeFilter} aCheckboxes={aCheckboxes} />;

    const nCustId = oLocalStorage.get('nCustId');
    const rcmpCardHeader = <CardHeader rcmpFilter={rcmpFilter} bIsItToInsertGoBackBtn={!!nCustId} history={history} />;
    return rcmpCardHeader;
  };

  render() {
    const { rcmpAlert, filterSearch, bShowCompletedCertifications } = this.state;
    return (
      <div className="v2-page-content consultant-panel">
        <BrandImage cFileName="logo-text-white-108x60.svg" className="logo" alt="logo" />
        <div className="card v2-page-card">
          {this.generateCardHeader()}
          <div className="card-body">
            {rcmpAlert}
            <CustomersProvider
              search={filterSearch}
              onSelect={this.validateCustomer}
              bShowCertifiedNorms={bShowCompletedCertifications}
              onError={this.onError}
            />
          </div>
        </div>
      </div>
    );
  }
}

const nameMatchesSearch = (name, search = '') => textSearchFormat(name).includes(textSearchFormat(search));

const CustomersContext = createContext();
const CustomersProvider = ({ search, bShowCertifiedNorms = false, onSelect, onError = () => { } }) => {
  const [bIsLoading, setIsLoading] = useState(true);
  const [bHasNextPage, setHasNextPage] = useState(true);
  const [aCustomers, setCustomers] = useState([]);
  const [nPage, setPage] = useState(1);

  const [aCustomersCache, setCustomersCache] = useState([]);

  const getFilteredCustomers = useCallback((customers, search) => {
    if (!search) return customers;

    return customers.reduce((acc, c) => {
      if (nameMatchesSearch(c.cust_cfantasyname, search)) {
        acc.push({ ...c });
      } else {
        const colNorms = c.colNorms?.filter(oNorm => nameMatchesSearch(oNorm.norm_cname, search)) ?? [];
        if (colNorms.length > 0) {
          acc.push({ ...c, colNorms });
        }
      }
      return acc;
    }, []);
  }, []);

  const getCustomers = useCallback(async () => {
    try {
      setIsLoading(true);

      const { data } = await Axios.get('/consultant', {
        params: {
          page: nPage
        }
      });

      const aNewCustomers = data.data;
      const bHasMore = data.hasNext;

      setHasNextPage(bHasMore);
      setPage(nCurrPage => nCurrPage + 1);

      setCustomersCache(aPrv => [...aPrv, ...aNewCustomers]);
    } catch (oError) {
      onError(oError);
    } finally {
      setIsLoading(false);
    }
  }, [bHasNextPage, nPage, search]);

  useEffect(() => {
    const aMatching = getFilteredCustomers(aCustomersCache, search);
    setCustomers(aMatching);
    if (bHasNextPage && aMatching.length === 0) {
      getCustomers();
    }
  }, [search, aCustomersCache]);

  const value = useMemo(
    () => ({
      aCustomers,
      bShowCertifiedNorms,
      onSelect,
      bIsLoading,
      bHasNextPage,
      getCustomers
    }),
    [aCustomers, bShowCertifiedNorms, onSelect, bIsLoading, bHasNextPage, getCustomers]
  );

  return (
    <CustomersContext.Provider value={value}>
      <CustomerGrid />
      {bIsLoading && (
        <div className="spinner-container">
          <div className="spinner" style={{ width: '50px', height: '50px' }} />
          <br />
          {intl.get('carregando')}
        </div>
      )}
    </CustomersContext.Provider>
  );
};

const CustomerGrid = () => {
  const { aCustomers, bIsLoading, bHasNextPage, getCustomers } = useContext(CustomersContext);

  const oObserverRef = useRef(null);
  const fnLastItemRef = useCallback(
    (elLastItem) => {
      if (bIsLoading) return;
      if (oObserverRef.current) {
        oObserverRef.current.disconnect();
      }
      if (!bHasNextPage) return;

      oObserverRef.current = new IntersectionObserver(
        ([oEntry]) => {
          if (!oEntry.isIntersecting) return;
          getCustomers();
        },
        {
          threshold: 0,
          rootMargin: '0px 200px 0px 200px'
        }
      );

      if (elLastItem) oObserverRef.current.observe(elLastItem);
    },
    [bIsLoading, bHasNextPage, getCustomers]
  );

  return (
    <div className="container-cards">
      <Masonry className="grid" elementType="ul">
        {aCustomers.map((c, i) => (
          <CustomerListItem
            key={c.cust_nid}
            oCustomer={c}
            bEnabled={c.cust_status !== 'inactive' || c.bisadmin}
            ref={i === aCustomers.length - 1 ? fnLastItemRef : null}
          />
        ))}
      </Masonry>
    </div>
  );
};

const CustomerListItem = forwardRef(({ oCustomer, bEnabled }, ref) => {
  const { onSelect } = useContext(CustomersContext);

  return (
    <li className="item" ref={ref}>
      <div className={`content ${!bEnabled ? 'inactive-block' : ''}`} onClick={() => onSelect(oCustomer, 0, false)}>
        <div className="header">
          <h2>{oCustomer.cust_cfantasyname}</h2>
          {oCustomer.wlpn_ctitle && (
            <span className="wl-customer-quality">White label: {oCustomer.wlpn_ctitle}</span>
          )}
        </div>
        <div className="contentRole">
          {oCustomer.cust_status === 'inactive' && (
            <span className="inactive-status-quality">Inativo desde: {oCustomer.cust_dinactive}</span>
          )}
          {oCustomer.colNorms?.map((oNorm) => (
            <NormListItem
              key={oNorm.norm_nid}
              oNorm={oNorm}
              onSelect={() => onSelect(oCustomer, oNorm.norm_nid, true)}
            />
          ))}
        </div>
      </div>
    </li>
  );
});

const NormListItem = ({ oNorm, onSelect }) => {
  const { bShowCertifiedNorms } = useContext(CustomersContext);

  if (bShowCertifiedNorms !== !!oNorm.norm_biscertified) return null;

  return (
    <div onClick={onSelect} className="norm">
      <h5>{intl.get('QualityPanelConsultant.certificacao', { cNormInitials: oNorm.norm_cinitials })}</h5>
      <div className="containerBar">
        <div className="progressBar">
          <span
            style={{
              width: `${oNorm.norm_nprogress}%`
            }}
            className="fill"
          />
        </div>

        <span className="tooltipNorma">
          <p>
            {intl.get('RequisiteIndex.status_concluido')} : {oNorm.finishedRequisites}{' '}
          </p>
          <p>
            {intl.get('RequisiteIndex.status_nao_aplica')} : {oNorm.notAppliedRequisites}{' '}
          </p>
          <p>
            {intl.get('RequisiteIndex.status_pendente')} : {oNorm.pendingRequisites}{' '}
          </p>
        </span>

        <span className="percent">{`${oNorm.norm_nprogress}%`}</span>
      </div>
    </div>
  );
};

export default QualityPanelIndex;
